import { create } from "zustand";
import { combine } from "zustand/middleware";

const useServerError = create(
  combine(
    {
      error: undefined as undefined | Error,
    },
    (set) => ({
      set,
    }),
  ),
);

export default useServerError;
